import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { AddressComponent } from '../components/address.component';
import storePersist from '../../../redux/storePersist';
export const AddressContainer = ({ onInnerFormChange, selectedAddress,isAddress }: any) => {
  const [
    stateValues,
    setStateValues
  ] = useState<any>([])

  const handleFilterToStates = (event: any) => {
    onInnerFormChange(
      event,
      'PrimaryAddress.CountryId',
      selectedAddress?.PrimaryAddress
    );

    if (event) {
      const filterStates: any = R.filter(
        (value: any) => value.CountryId === event,
        statesItems
      );
      if (filterStates.length) {
        setStateValues(filterStates);
      } else {
        setStateValues(statesItems);
      }
    } else {
      setStateValues([])
    }
  }

useEffect(() => {
  if(selectedAddress?.PrimaryAddress?.CountryId){
    handleFilterToStates(selectedAddress?.PrimaryAddress?.CountryId)
  }
 
}, [])
const statesItems = storePersist?.get("states")?.current?.items;
const countriesItems = storePersist?.get("countries")?.current?.items;
const librariesItems = storePersist?.get("library")?.current;

return (
        <AddressComponent
        isAddress={isAddress}
            onFilterToStates={handleFilterToStates}
            onInnerFormChange={onInnerFormChange}
            selectedAddress={selectedAddress}
            stateValues={stateValues}
            countries={countriesItems}
            libraries={librariesItems}
        />
  )
}
